import { render } from "./Access.vue?vue&type=template&id=04e49877"
const script = {}

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__